import { Box, Skeleton, useTheme } from "@mui/material"

export const SkeletonDirectionOverviewSidebar = () => {
  const theme = useTheme()
  const {
    root,
    headerWrapper,
    locationText,
    durationText,
    contentWrapper,
    durationWrapper,
    qrCodeContainer,
    qrCode,
    qrcodeText,
    stepContainer,
    stepListContainer,
    actionContainer,
    startButton,
  } = theme.components[`SkeletonDirectionOverviewSidebar`]?.styleOverrides || {}

  return (
    <Box sx={root}>
      <Box sx={headerWrapper}>
        <Skeleton sx={locationText} variant="text" />
      </Box>
      <Box sx={contentWrapper}>
        <Box sx={durationWrapper}>
          <Skeleton sx={durationText} variant="text" />
          <Skeleton sx={durationText} variant="text" />
          <Skeleton sx={durationText} variant="text" />
        </Box>
      </Box>
      <Box sx={stepContainer}>
        <Skeleton sx={stepListContainer} variant="rounded" />
      </Box>
      <Box sx={qrCodeContainer}>
        <Skeleton sx={qrCode} variant="rounded" />
        <Skeleton sx={qrcodeText} variant="text" />
      </Box>
      <Box sx={actionContainer}>
        <Skeleton sx={startButton} variant="rounded" />
      </Box>
    </Box>
  )
}
